import {
  Box,
  Divider,
  ListSubheader,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGoogle,
  faApple,
  faMicrosoft,
} from "@fortawesome/free-brands-svg-icons";
import { CalendarEventData } from "./CalendarEventData";
import { buildGoogleCalendarUrl, buildOutlookUrl } from "./calendarUrlHelpers";

export interface CalendarPickerDialogProps {
  anchorRef: React.RefObject<HTMLElement>;
  open: boolean;
  onClose: () => void;
  event: CalendarEventData;
  onIcsDownload: () => void;
}

interface CalendarRow {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

export const CalendarPickerDialog = ({
  anchorRef,
  open,
  onClose,
  event,
  onIcsDownload,
}: CalendarPickerDialogProps) => {
  const openUrl = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
    onClose();
  };

  const rows: CalendarRow[] = [
    {
      icon: <FontAwesomeIcon icon={faGoogle} color="#4285F4" fontSize={20} />,
      label: "Google Calendar",
      onClick: () => openUrl(buildGoogleCalendarUrl(event)),
    },
    {
      icon: <FontAwesomeIcon icon={faApple} color="#000000" fontSize={20} />,
      label: "Apple Calendar",
      onClick: () => {
        onIcsDownload();
        onClose();
      },
    },
    {
      icon: <FontAwesomeIcon icon={faMicrosoft} color="#0078D4" fontSize={20} />,
      label: "Outlook",
      onClick: () => openUrl(buildOutlookUrl(event)),
    },
  ];

  return (
    <Menu
      anchorEl={anchorRef.current}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "0.75rem",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 4px 16px",
            minWidth: 240,
            mt: 1,
          },
        },
      }}
    >
      <ListSubheader
        sx={{
          fontSize: "1rem",
          fontWeight: 600,
          color: "#000",
          lineHeight: "44px",
          borderBottom: "1px solid #E0E0E0",
          mb: 0.5,
        }}
      >
        Add to Calendar
      </ListSubheader>

      {rows.map((row) => (
        <MenuItem key={row.label} onClick={row.onClick} sx={{ py: 1.5, gap: 2 }}>
          <Box sx={{ width: 22, display: "flex", justifyContent: "center" }}>
            {row.icon}
          </Box>
          <Typography sx={{ fontSize: 15, fontWeight: 400 }}>
            {row.label}
          </Typography>
        </MenuItem>
      ))}

      <Divider sx={{ my: 0.5 }} />

      <MenuItem onClick={onClose} sx={{ py: 1.5, gap: 2 }}>
        <Box sx={{ width: 22, display: "flex", justifyContent: "center" }}>
          <Close sx={{ fontSize: 20, color: "grey.500" }} />
        </Box>
        <Typography sx={{ fontSize: 15, fontWeight: 400, color: "grey.600" }}>
          Skip
        </Typography>
      </MenuItem>
    </Menu>
  );
};
